const eloPattern = new RegExp(
  '^(' +
    '4011(78|79)|' +
    '43(1274|8935)|' +
    '45(1416|7393|763(1|2))|' +
    '50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|' +
    '627780|' +
    '63(6297|6368|6369)|' +
    '(65003[5-9]|65004[0-3]|65004[8-9]|' +
    '6500[5-9][0-9]|6501[0-9][0-9]|' +
    '65107[0-7]|65108[0-8]|6510[0-6][0-9]|' +
    '6516[5-7][0-9]|6550[0-1][0-9]|' +
    '65502[1-9]|6550[3-4][0-9]|65505[0-8])' +
    ')',
);

const patterns = [
  { brand: 'ELO', pattern: eloPattern },
  {
    brand: 'HIPERCARD',
    pattern: /^(606282|3841(0[0-9]|4[0-9]|6[0-9]|[89][0-9]))/,
  },
  { brand: 'AMEX', pattern: /^3[47]/ },
  {
    brand: 'MASTERCARD',
    pattern: /^(5[1-5]|2(22[1-9]|2[3-9]\d|[3-6]\d{2}|7[01]\d|720))/,
  },
  { brand: 'VISA', pattern: /^4/ },
];

const detectCardBrand = (cardNumber) => {
  const number = cardNumber.replace(/\D/g, '');
  const found = patterns.find(({ pattern }) => pattern.test(number));
  return found ? found.brand : null;
};

export default detectCardBrand;
